import NotificationIcon from '../icons/NotificationIcon';
import { Stack } from '@mui/material';
import { colors } from 'theme/mui/colors';
import { INewsDto } from 'api/news/dtos';

type Props = {
  isClicked: boolean;
  data: INewsDto[];
};

const NotificationsIcon = (props: Props) => {
  const { isClicked, data } = props;

  return (
    <>
      <NotificationIcon style={{ position: 'relative' }} />
      {data?.length && !isClicked ? (
        <Stack
          sx={{
            backgroundColor: colors.pink[500],
            color: colors.base.white,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '0.5rem',
            height: '0.5rem',
            position: 'absolute',
            borderRadius: '50%',
            bottom: 24,
            right: 8,
          }}
        />
      ) : null}
    </>
  );
};

export default NotificationsIcon;
